import { getTenant } from "./tenantResolver";

/**
 * Cesty, ktore basename z <BrowserRouter> NEprefixuje.
 *
 * <Link>, navigate() a <Navigate> si prefix /veteran pridaju samy. Obycajny
 * <a href="/vop"> alebo window.location.assign(...) ho nevidia -- vtedy
 * tenantPath("/vop") -> "/veteran/vop".
 *
 * Staticke subory z public/ (logo, video, favicon) su vzdy na koreni domeny,
 * nie pod prevadzkou: publicAsset("rozvozy_icon.png") -> "/rozvozy_icon.png".
 * Relativne src="rozvozy_icon.png" by pod /veteran/kontakt hladalo
 * /veteran/rozvozy_icon.png a logo by sa rozbilo.
 */
export function tenantPath(path = "/") {
  const p = path.startsWith("/") ? path : `/${path}`;
  const base = getTenant().basename;
  if (!base) return p;
  return p === "/" ? base : `${base}${p}`;
}

export function publicAsset(file) {
  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  return `${base}/${String(file).replace(/^\/+/, "")}`;
}

/** Adresa inej prevadzky na tej istej zdielanej domene (platformova sprava). */
export const slugPath = (slug, path = "") => `/${slug}${path}`;
